/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Waffo_Merchant_IdInputs */

const en_admin_settings_fields_waffo_merchant_id = /** @type {(inputs: Admin_Settings_Fields_Waffo_Merchant_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merchant ID`)
};

/**
* | output |
* | --- |
* | "Merchant ID" |
*
* @param {Admin_Settings_Fields_Waffo_Merchant_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_waffo_merchant_id = /** @type {((inputs?: Admin_Settings_Fields_Waffo_Merchant_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Waffo_Merchant_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_waffo_merchant_id(inputs)
});
export { admin_settings_fields_waffo_merchant_id as "admin.settings.fields.waffo_merchant_id" }